import { frontendURL } from '../../../../helper/URLHelper';

const SettingsContent = () => import('../Wrapper.vue');
const BillingIndex = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/billing'),
      meta: {
        permissions: ['administrator'],
      },
      component: SettingsContent,
      props: {
        headerTitle: 'SETTINGS.BILLING',
        icon: 'wallet-outline',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'settings_billing',
          component: BillingIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
